<template>
	<div class="message-controls">
		<transition name="fade" mode="out-in">
			<svg-icon
				:name="copySuccess ? 'copySuccess' : 'copy'"
				@click="copy({ text, imageUrl })"
				:class="copySuccess ? 'message-controls-control-success' : 'message-controls-control'"
				:size="sizeControls"
				data-test-id="icon-copy"
			/>
		</transition>
		<transition v-if="imageUrl" name="fade" mode="out-in">
			<svg-icon
				name="download"
				@click="downloadImg"
				:size="sizeControls"
				data-test-id=""
				:class="'message-controls-control'"
			/>
		</transition>
	</div>
</template>

<script setup lang="ts">
import SvgIcon from '@/components/SvgIcon.vue'

import { useClipboard } from '@/composables/useClipboard'

const { copySuccess, copy } = useClipboard()

const props = defineProps({
	imageUrl: { type: String },
	text: { type: String },
	sizeControls: { type: Number, default: 16 }
})

async function downloadImg() {
	if (props.imageUrl) {
		try {
			const response = await fetch(props.imageUrl)
			const blob = await response.blob()
			const blobUrl = URL.createObjectURL(blob)

			const link = document.createElement('a')
			link.href = blobUrl
			link.download = `image_${new Date().getTime()}.jpg`

			link.click()
			URL.revokeObjectURL(blobUrl)
		} catch (error) {
			console.error('Ошибка при скачивании изображения:', error)
		}
	}
}

// function openShareDialog() {}
</script>

<style lang="scss" scoped>
.message-controls {
	width: 100%;
	@include flex-end;
	gap: 8px;
	margin-top: 8px;
	& svg {
		cursor: pointer;
		color: var(--text-secondary);
		@media (min-width: $screen-mobile) {
			&:hover {
				color: var(--text-secondary-hover);
			}
			&:active {
				color: var(--text-secondary-hover);
			}
		}
	}
	&-control {
		cursor: pointer;
		transition: $transition-opacity;
		opacity: 0.5;
		@media (min-width: $screen-mobile) {
			&:hover {
				opacity: 1;
			}
			&:active {
				opacity: 0.1;
			}
		}
		&--active {
			opacity: 1;
		}
		&-success {
			color: var(--text-primary);
		}
	}
}
</style>
